export enum FileType {
	csv = "csv",
	pdf = "pdf",
	html = "html",
	xlsx = "xlsx",
}

export enum MobilePlatform {
	ios = "ios",
	android = "android",
}

export enum NgucAPIUrl {
	production = "https://api-nguc.weblink.se",
	beta = "https://beta-api-nguc.weblink.se",
}

export enum EventPusherUrl {
	production = "https://event-nguc.weblink.se",
	beta = "https://beta-event-nguc.weblink.se",
}

export enum TemplateType {
	mobile = "mobile",
	desktop = "desktop",
	teams = "teams",
}
